import React from 'react'

import { Route, Routes, BrowserRouter, HashRouter, Navigate }  from 'react-router-dom'
import { ThemeProvider } from '@mui/material'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import AuthProvider, { AuthIsSignedIn, AuthIsNotSignedIn } from './contexts/auth/authContext'
import DataProvider from './contexts/data/dataContext'

import Impersonate from './pages/auth/impersonate'
import SignIn from './pages/auth/signIn'
import ChangePassword from './pages/auth/changePassword'
import RequestCode from './pages/auth/requestCode'
import VerifyCode from './pages/auth/verifyCode'
import Dashboard from './pages/dashboard'
import Performance from './pages/performance'
import Savings from './pages/savings'
import Profile from './pages/profile'
import UserManual from './pages/userManual'
import szCustomMuiTheme from './components/common/theme/szCustomMuiTheme'

export const apiQueryClient = new QueryClient()

const SignInRoute: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<SignIn />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/requestcode" element={<RequestCode />} />
      <Route path="/verifycode" element={<VerifyCode />} />
      <Route path="/passwordchange" element={<ChangePassword />} />
      <Route path="*" element={<Navigate to="/" replace={true} />} />
    </Routes>
  </BrowserRouter>
)

const CommonRoute: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/impersonate" element={<Impersonate />} />
      <Route path="/usermanual" element={<UserManual />} />
      <Route path="*" element={<Navigate to="/" replace={true} />} />
    </Routes>
  </BrowserRouter>
)

const MainRoute: React.FC = () => (
  <HashRouter>
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/performance" element={<Performance />} />
      <Route path="/savings" element={<Savings />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="*" element={<Navigate to="/" replace={true} />} />
    </Routes>
  </HashRouter>
)

const App: React.FC = () => (
  <ThemeProvider theme={szCustomMuiTheme}>
    <QueryClientProvider client={apiQueryClient}>
      <AuthProvider>
        <CommonRoute />
        <AuthIsSignedIn>         
          <DataProvider>
            <MainRoute />
          </DataProvider>
        </AuthIsSignedIn>
        <AuthIsNotSignedIn>
          <SignInRoute />
        </AuthIsNotSignedIn>
      </AuthProvider>
    </QueryClientProvider>
  </ThemeProvider>
)

export default App;
